import { cx } from '@linaria/core'

import { Camera2Icon, CameraIcon } from '~/components/icons'

export const AddImage: React.FC<{ className: string; useCamera2?: boolean }> = (
  props
) => {
  return (
    <div className={cx('bg-[#E7E7E7] rounded-md', props.className)}>
      <div className="flex items-center h-full">
        <div className="mx-auto">
          {props.useCamera2 ? (
            <Camera2Icon className="fill-[#AEAEAE] w-8 h-6 mx-auto" />
          ) : (
            <CameraIcon className="fill-[#AEAEAE] w-6 h-6 mx-auto" />
          )}
          <p className="text-[#AEAEAE] text-xs text-center m-1 leading-5">
            写真を追加
          </p>
        </div>
      </div>
    </div>
  )
}
